module["exports"] = [
  "/34##-######-####L/",
  "/37##-######-####L/"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/credit_card/american_express.js
// module id = 882
// module chunks = 1